module.exports = __webpack_public_path__ + "img/2025-12-20a_1.b0a432fc.jpg";